module.exports = __webpack_public_path__ + "img/subcategory.0d2e7133.png";